import { useEffect, useState } from 'react';

export function useKeyHolder(basicKey: string): boolean {
  const [basicKeyHeld, setBasicKeyHeld] = useState(false);

  const downHandler = ({ key }) => {
    if (key === basicKey) {
      setBasicKeyHeld(true);
    }
  };

  const upHandler = ({ key }) => {
    if (key === basicKey) {
      setBasicKeyHeld(false);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, []);

  return basicKeyHeld;
}
